define(function(require, exports, module) {
    'use strict';

    const _ = require('underscore');
    const HouseNumberProvider = require('common/addressLookupSwiss/sourceProviders/houseNumberProvider');
    const AbstractProvider = require('common/addressLookupSwiss/sourceProviders/abstractProvider');

    var parent = {
        fetch: AbstractProvider.prototype.fetch
    };

    HouseNumberProvider.prototype.prepareRequest = function(searchText, prevSearchResult) {
        if (searchText.trim().length === 0) {
            return null;
        }
        const data = AbstractProvider.prototype.prepareRequest(searchText, prevSearchResult);

        data.request = {
            ...data.request,
            HouseNumber: searchText,
            TownName: prevSearchResult.city,
            Streetname: prevSearchResult.streetName
        };

        return data;
    };

    HouseNumberProvider.prototype.isValid = function(searchText) {
        return /^(?:(?!_)[\w\/-])*$/.test(searchText);
    };

    HouseNumberProvider.prototype.fetch = function(params) {
        // Gaps in request not allowed. Request should contain number.
        const isGaps = params && params.request.HouseNumber === '000011101010101010100777';

        if (isGaps) {
            let promises = [];
            for (let i = 0; i < 9; i++) {
                params.request.HouseNumber = String(i + 1);
                promises.push(parent.fetch.call(this, params));
            }

            return Promise.all(promises).then(function(response) {
                const re = /\D/g;
                let filtered = response.filter(function(el) {
                    return !el.errorCode;
                });
                let flat = _.flatten(filtered);

                return flat.sort(function(a, b) {
                    return parseInt(a.houseNumber.replace(re, '')) - parseInt(b.houseNumber.replace(re, ''));
                });
            });
        }

        return parent.fetch.apply(this, arguments);
    };

    HouseNumberProvider.prototype.format = function(row) {
        const inputTxt = this.lastInput.toLowerCase();
        return AbstractProvider.prototype.highlightResult.call(this, row.houseNumber, inputTxt);
    };

    module.exports = HouseNumberProvider;
});
